import imgFE01 from "../components/common/app2soft/images/001_fe/pexels-photo-212286.jpg";
import imgFE02 from "../components/common/app2soft/images/001_fe/people-woman-coffee-meeting.jpg";
import imgFE03 from "../components/common/app2soft/images/001_fe/people-coffee-tea-meeting.jpg";
import imgFE04 from "../components/common/app2soft/images/001_fe/pexels-photo-450271.jpg";

import imgBE01 from "../components/common/app2soft/images/002_be/pexels-photo-140945.jpeg";
import imgBE02 from "../components/common/app2soft/images/002_be/pexels-photo-530024.jpeg";
import imgBE03 from "../components/common/app2soft/images/002_be/pexels-photo-440581.jpeg";

import imgUI01 from "../components/common/app2soft/images/003_ui/hands-people-woman-working.jpg";
import imgUI02 from "../components/common/app2soft/images/003_ui/startup-photos.jpg";

import imgMI01 from "../components/common/app2soft/images/004_mi/woman-typing-writing-windows.jpg";
import imgMI02 from "../components/common/app2soft/images/004_mi/computer-pc-workplace-home-office-159760.jpeg";

import imgMO01 from "../components/common/app2soft/images/005_mo/pexels-photo-341523.jpeg";
import imgMO02 from "../components/common/app2soft/images/005_mo/pexels-photo-177707.jpeg";
import imgMO03 from "../components/common/app2soft/images/005_mo/pexels-photo-58639.jpeg";

import imgDA01 from "../components/common/app2soft/images/006_da/pexels-photo-159888.jpeg";
import imgDA02 from "../components/common/app2soft/images/006_da/pexels-photo-212286.jpg";

import imgDE01 from "../components/common/app2soft/images/007_de/pexels-photo-289927.jpeg";
import imgDE02 from "../components/common/app2soft/images/007_de/pexels-photo-306534.jpeg";
import imgDE03 from "../components/common/app2soft/images/007_de/pexels-photo-257897.jpeg";
import imgDE04 from "../components/common/app2soft/images/007_de/pexels-photo-276549.jpeg";

import imgAdam from "../components/common/app2soft/images/image003.jpg";
import imgJessica from "../components/common/app2soft/images/image002.png"


export const FrontEndPage = {
  name: "Front End Development",
  title: "We can help you build up your own cost effective nearshore team with all the skills required for a supreme front end development.",
  keywords: "Front end development, PHP web development, responsive web development, JavaScript development, web application development",
  content:[
    {
      title: "Front End Development",
      text: "The right design, typography and colors are needed for your end users to have a pleasant journey through your website and App2soft's expertise can ensure that.  Some of our Front End inventory technologies include Angular JS, React JS, RAD JS, HTML, JavaScript, CSS, ActionScript, Objective C, Bootstrap, Semantic UI, jQuery Mobile",
      image: imgFE01
    },
    {
      title: "PHP Web Development",
      text: "This widely used scripting language is becoming more suitable for web development practices. We offer high-end PHP development with notorious results across a variety of business verticals.",
      image: imgFE02
    },
    {
      title: "Responsive web development",
      text: "With a variety of electronic screen size devices a different approach in design and development for content must be done. Our development team has the skill-set needed for a responsive solution to adapt your content to the end user's  behavior and screen size device. ",
      image: imgFE03
    },
    {
      title: "Web application development",
      text: "We build the right  Web Application Development solutions for each of our clients. These services include a unique and custom made website design, online solutions, and web based solutions built by a dedicated team for your company",
      image: imgFE04
    }
  ]
}

export const BackEndPage = {
  name: "Back End Programming",
  title: "We can help you build up your own cost effective nearshore team with all the skills required for a supreme back end development.",
  keywords: "PHP software development company, python development, ruby on rails development",
  content:[
    {
      title: "PHP Software Development Company",
      text: "If looking to ensure success in your upcoming PHP development projects we are the right company for you. We have built a great development practices in different technologies for successful and innovative companies. We can get the best talent to ensure we can have success together in your projects.",
      image: imgBE01
    },
    {
      title: "Python Development",
      text: "This cost-effective open source programming language is useful for our web development and test automation services. With our Python practice we build top development solutions, faster development cycles and an easily understood format for a faster comprehension of our clients.",
      image: imgBE02
    },
    {
      title: "Ruby on Rails Development",
      text: "Many e-commerce platform, business websites, diverse applications use RoR for their development. We’ve put together a Ruby team that can manage your layout design, hosting, migration, maintenance and QA for all of the Ruby on Rails development. Our nearshore team will make sure you’ll get a hit in your project kickoff.",
      image: imgBE03
    }
  ]
}

export const UiUxPage = {
  name: "UI and UX",
  title: "We can help you build up your own cost effective nearshore team with all the skills required for a supreme  UI and UX development.",
  keywords: "ui ux designer, css programming, saas product development, ux development,",
  content:[
    {
      title: "UI and UX Designer",
      text: "For an excelling results for your customer’s journey in your website it’s necessary to bring UI and UX designers to work as one. Our UX developers are completely focused end users have a great experience concerning your product while our UI developers visually effectively communicate the right message for the users.",
      image: imgUI01
    },
    {
      title: "Saas Product Development",
      text: "We are ready to build you a world-class Saas product and have a success story together. Our complete end to end solution for this success story include a high cost-effective operations, managing cloud hosting, an innovative solution and a great user experience ux development",
      image: imgUI02
    }
  ]
}


export const MicrosoftPage = {
  name: "Microsoft Software",
  title: "We can help you build up your own cost effective nearshore team with all the skills required for a supreme. Net development.",
  keywords: "net development, c# application development",
  content:[
    {
      title: "Net Development",
      text: "Our Microsoft Certified Professional team has a vast experience in a top development environment that includes advanced NET architecture design, web services, performance tuning, migrations and custom NET web applications.",
      image: imgMI01
    },
    {
      title: "C# Application Development",
      text: "More and more software solutions are being developed in a Net environment using C#. To keep up with the growth we have put together an outstanding team that can solve any problem you throw at them with an innovative cost-effective solution",
      image: imgMI02
    }
  ]
}

export const MobilePage = {
  name: "Mobile Development",
  title: "We can help you build up your own cost effective nearshore team with all the skills required for a supreme mobile development.",
  keywords: "mobile development, ios development, android programming",
  content:[
    {
      title: "Mobile development",
      text: "We develop brilliant native and hybrid apps with advanced mobile applications tools. We are able to surpass our client's expectations by designing, building, running and analyzing highly customized apps.",
      image: imgMO01
    },
    {
      title: "Android Programming",
      text: "Most smartphones worldwide operate on an Android platform. Our Android programming expertise will guarantee the proper development for your Android applications",
      image: imgMO02
    },
    {
      title: "iOS Development",
      text: "Not worrying about your iOS development team is a big challenge for most but having the best nearshore team will sure get rid of the problem. Our services aren’t limited to just a native iOS development but also providing a complete solution including the app design, development, enhancement and monetization.",
      image: imgMO03
    }
  ]
}

export const DatabasePage = {
  name: "Database Development",
  title: "We can help you build up your own cost effective nearshore team with all the skills required for a supreme database management.",
  keywords: "database development, mysql frontend, big data analytics",
  content:[
    {
      title: "Database Development",
      text: "A good Database practice is the foundation of almost every business process. Our Database services include multiple sources integration, performance testing, database migrations, implementation, design and analysis. ",
      image: imgDA01
    },
    {
      title: "Big Data Analytics",
      text: "Manually examining multiple spreadsheets is an old and ineffective concept replaced by Big Data. Our practices in the visualization and examination of large amounts of data are a superb service we offer our clients for them to attain a cost reduction in the examination of data, faster and better decision making actions.",
      image: imgDA02
    }
  ]
}

export const DevOpsPage = {
  name: "DevOps Practices",
    title: "We can help you build up your own cost effective nearshore team with all the skills required for a supreme DevOps practice.",
  keywords: "Continuous Delivery, Continuous Deployment, Cloud Based Solutions, Continuous Integration",
  content:[
    {
      title: "Continuous Deployment",
      text: "Easy release, well tested software and fast development cycles are essential to stay competitive on today's market. As fast you give your customer new features, security updates, as fast as your business grow and we want to be part of your success.",
      image: imgDE01
    },
    {
      title: "Continuous Integration",
      text: "Because of the Deployment needed  implementing Continuous Integration will help your team to focus on writing great code. Automating testing and giving developers tools to find bugs earlier and have faster and better development cycles.",
      image: imgDE02

    },
    {
      title: "Continuous Delivery",
      text: "In addition Continuous Delivery makes your release cycles, smarter, faster, and easier, so that you can focus on your customers. Continuous Delivery and Continuous Integration are becoming the next big thing in relation to deliver and support software.",
      image: imgDE03
    },
    {
      title: "Cloud Based Solutions",
      text: "Cloud Services are the best way to increase agility, elasticity, redundancy and lower operation costs , having the right talent will help you leverage your business.",
      image: imgDE04
    }
  ]
}

export const AboutUsPage = {
  name: "About Us",
  title: "About Us",
  keywords: "Continuous Delivery, Continuous Deployment, Cloud Based Solutions, Continuous Integration",
  content:[
    {
      title: "About Us",
      text: "We are a custom software development firm achieving rapid delivery cycles, stable, test-driven software, and streamlined IT processes since 2008. Located in Costa Rica, the heart of Latin America, we provide assistance to US companies in the creation of their own nearshore software development team. Getting the best developers of the country in a similar US time zone with a cost-effective performance is what we guarantee to each of our clients.",
      image: imgDE01
    },
    {
      title: "Sustainability",
      text: "Costa Rica is currently known to be a worldwide leader in sustainability with its 93% of renewable energy and on it’s way to permanently be the number one nation worldwide with 100 percent in this ecological balance. This small country also houses a 5% of the planet’s biodiversity. With these facts just imagine having an extension of your office with rainforest and beautiful beaches all around.",
      image: imgDE02

    },
    {
      title: "Political Stability",
      text: "Costa Rica a strong democratic country that abolished its army since 1949 to invest the national defense budget to education. Leading as the most prosperous country in Central America and one of the most developed in all Latin America. The country has become one of the highest standards of living and one with the lowest levels of poverty.",
      image: imgDE03  
    }
  ]
}

export const ClientsPage = {
  name: "Clients",
  title: "Meet our most outstanding and fastest growing clients",
  keywords: "Continuous Delivery, Continuous Deployment, Cloud Based Solutions, Continuous Integration",
  content:[
    {
      title: "Packsize",
      text: "Founded in 2002, Over 300 employees, $100 to $500 million in Revenue ",
      image: imgDE01
    },
    {
      title: "Hanko Kiessner - CEO ",
      text: "“The Costa Rica office is an essential business partner and we continue to look to them for reliable service. We greatly appreciate our association with  App2Soft.”",  
      image: imgDE02

    },
    {
      title: "Ken Fultz - Global Software Manager: ",
      text: "“App2Soft is a world-class resource provider. The talent they have acquired for our software and QA teams is exceptional”",
      image: imgDE03
    },{
      title: "CR England",
      text: "Founded in 1920, 5,001-10,000 employees, Over $1.1 Billion in Revenue ",
      image: imgDE01
    },
    {
      title: "Rich Farr - VP of Technology",
      text: "“Our developers in Costa Rica have quickly become highly-valued members of our technology and business teams. They are a vital part of our team and critical to our development strategy. App2Soft has made it easy to build up and manage this high-powered team.”",
      image: imgDE02

    },
    {
      title: "Thomas Casselberry – Software Development Director:",
      text: "“Having managed development teams all over the world, I’ve finally found a team location that really works with our need for real-time collaboration during U.S. work hours and without the communication challenges, misinterpretation of requirements, and the many struggles with project timelines. Our Costa Rica team is driven, dedicated, and has got to be one of the most talented teams I have worked with, anywhere!”  ",
      image: imgDE03
    }
  ]
}

export const TeamContent = {
  name: "Team",
  title: "We believe in a friendly and open attitude. We also believe in the strength of people and competencies coming together to achieve something great.",
  keywords: "Continuous Delivery, Continuous Deployment, Cloud Based Solutions, Continuous Integration",
  content:[
    {
      title: "CJ Sanchez<span>Co-founder</span><span>cj.sanchez@app2soft.com</span>",
      text: "CJ Sanchez has been in Costa Rica for 20 years working in multiple technology fields. He is an entrepreneur with a background in building an overseas NCO, as well as developing and managing virtual IT teams for companies like Pfiser, Del Monte, Motorola, Toshiba, and HP. Currently he’s managing the growing opportunities related to the expansion of App2Softs near-shoring and project based models for our United States Customers . This includes employee hiring, call center management, talent acquisition, KPI’s and Metrics, Budgeting, and our external pricing model. ",
      image: imgDE01
    }
  ]
}




// WEBPACK FOOTER //
// ./src/api/PageContent.js